import { ENTRY_DATA_SECTION_KEYS, RegulatoryLabel } from "@frontend/common";

import { ClinicalTrials } from "@/types/clinicalTrials.types";
import { ClinicalTrialStatus } from "@/types/clinicalTrialStatus.types";
import { CompanyWebsiteVariousPage } from "@/types/companyWebsiteVariousPage";
import { ConferenceSchedule } from "@/types/conferenceSchedule.types";
import { CTG } from "@/types/ctg.types";
import { DealsLaSc } from "@/types/dealLaSc.types";
import { DealFiling, Deals } from "@/types/deals.types";
import { ExpeditedProgram } from "@/types/expeditedProgram.types";
import { Publication } from "@/types/publication.types";
import { PublicationJournal } from "@/types/publicationJournal.types";
import { Regulatory } from "@/types/regulatory.types";
import { VentureCapital, FundingFiling } from "@/types/ventureCapital.types";
import { useUpdateEntryDataMutate } from "@api/entryData/entryData";
import { getPressIdFromURL } from "@utils/getStateFromURL";

import { useSectionCodeToClassification } from "./useSectionCode";

export const useUpdateEntryData = () => {
  const { mutateAsync: updateEntryDataMutate } = useUpdateEntryDataMutate(
    getPressIdFromURL(),
  );

  const sectionCode = useSectionCodeToClassification();

  const updateEntryData = async (
    entryData: Partial<{
      [ENTRY_DATA_SECTION_KEYS.clinicalTrial]: Partial<ClinicalTrials>;
      [ENTRY_DATA_SECTION_KEYS.clinicalTrialStatus]: Partial<ClinicalTrialStatus>;
      [ENTRY_DATA_SECTION_KEYS.regulatory]: Partial<Regulatory>;
      [ENTRY_DATA_SECTION_KEYS.deals]: Partial<Deals>;
      [ENTRY_DATA_SECTION_KEYS.dealsLaSc]: Partial<DealsLaSc>;
      [ENTRY_DATA_SECTION_KEYS.expeditedProgram]: Partial<ExpeditedProgram>;
      [ENTRY_DATA_SECTION_KEYS.companyWebsiteVariousPages]: Partial<CompanyWebsiteVariousPage>;
      [ENTRY_DATA_SECTION_KEYS.ventureCapital]: Partial<VentureCapital>;
      [ENTRY_DATA_SECTION_KEYS.publication]: Partial<Publication>;
      [ENTRY_DATA_SECTION_KEYS.publicationJournal]: Partial<PublicationJournal>;
      [ENTRY_DATA_SECTION_KEYS.conferenceSchedule]: Partial<ConferenceSchedule>;
      [ENTRY_DATA_SECTION_KEYS.dealFiling]: Partial<DealFiling>;
      [ENTRY_DATA_SECTION_KEYS.fundingFiling]: Partial<FundingFiling>;
      [ENTRY_DATA_SECTION_KEYS.ctg]: Partial<CTG>;
      [ENTRY_DATA_SECTION_KEYS.regulatoryLabel]: Partial<RegulatoryLabel>;
      [ENTRY_DATA_SECTION_KEYS.patent]: Partial<RegulatoryLabel>;
    }>,
    isDbSaved?: boolean,
  ) => {
    await updateEntryDataMutate({
      entryData,
      isDbSaved: isDbSaved || false,
      sectionCode,
    });
  };

  return updateEntryData;
};
